import React from 'react';
import { IContent } from '../../../types';
import { withContent } from '../../../hoc/withContext';
import './Advantage.scss';
import Image from '../Image/Image';

interface IAdvantageProps {
  context?: IContent;
  index: number;
  info: {
    description: string;
    image: string;
    legal?: string;
  };
}

const Advantage = ({ context, info, index }: IAdvantageProps) => {
  const { image, description, legal } = info;

  return (
    <li className="advantage">
      <div className="advantage-container">
        <div className="advantage-image">
          <Image
            className={['advantage-image-' + index]}
            imageName={image}
            altText={description}
          />
        </div>
        <div className="advantage-description-container">
          <div className="advantage-description">{description}</div>
          {legal && (
            <div
              className="advantage-legal"
              dangerouslySetInnerHTML={{ __html: legal }}
            />
          )}
        </div>
      </div>
    </li>
  );
};

export default withContent(Advantage);
